var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-full"},[_c('video',{ref:"video",attrs:{"controls":"","crossorigin":"","playsinline":"","data-poster":_vm.poster}},[_c('source',{ref:"source",attrs:{"type":"application/x-mpegURL","src":_vm.videoSrc}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }